<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input class="form-control" type="text" v-model="block.header" :placeholder="$t('Header')" maxlength="200" />
    </div>

    <hr />

    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="standard"
              v-model="galleryType"
              value=""
            />
            <label class="form-check-label" for="standard">
              {{ 'Standard' | translate }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="column"
              v-model="galleryType"
              value="column"
            />
            <label class="form-check-label" for="column">
              {{ 'Lightbox grid' | translate }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="radio"
              v-model="galleryType"
              value="slider"
            />
            <label class="form-check-label" for="radio">
              {{ 'Slider' | translate }}
            </label>
          </div>
        </div>
        <div v-if="galleryType === 'slider'" class="mb-3">
          <div class="form-check form-switch mt-2">
            <input
              type="checkbox"
              class="form-check-input"
              v-model="sliderAutoplay"
              value="1"
              :id="`slider-autoplay-${block.id}`"
            />
            <label class="form-check-label" :for="`slider-autoplay-${block.id}`">
              <small>{{ 'Slider autoplay' | translate }}</small>
            </label>
          </div>
        </div>
      </div>
      <draggable :list="images" handle=".grabbable">
        <div v-for="(image, index) in images" :key="image.path || index" class="col-4 mb-3 d-flex align-items-center">
          <i class="fas fa-bars grabbable me-3"></i>
          <ImageUpload
            :file-path="image.path"
            context="block.gallery"
            @fileDeleted="imageDeleted(index, image)"
            @uploadCompleted="imageUploaded($event, index, image)"
          ></ImageUpload>
        </div>
      </draggable>
    </div>
    <div class="small text-muted">
        {{ 'TIP' | translate }}:
        {{ 'Use images with the same size' | translate }}.
    </div>
    <div class="mt-3">
      <button @click="add" class="btn btn-primary">
        {{ 'Add' | translate }}
      </button>
    </div>
  </div>
</template>

<script>
import ImageUpload from './../ImageUpload'
import _ from 'lodash'
import draggable from 'vuedraggable'

export default {
  components: {
    ImageUpload,
    draggable,
  },
  props: ['block'],
  data() {
    return {
      images: this.block.data || [],
      galleryType: _.get(this.block, 'settings.gallery_type') || '',
      sliderAutoplay: _.get(this.block, 'settings.slider_autoplay') || '',
    }
  },
  updated() {
    this.change()
  },
  methods: {
    change() {
      let previousSettings = _.get(this.block, 'settings')
      let newSettings = { gallery_type: this.galleryType, slider_autoplay: this.sliderAutoplay }
      if (previousSettings) {
        newSettings = {
          ...previousSettings,
          ...newSettings,
        }
      }
      newSettings = _(newSettings)
        .omitBy(_.isNil)
        .omitBy((value) => _.isEmpty(value) && !_.isInteger(value) && !_.isBoolean(value))
        .value()
      if (_.isEmpty(newSettings)) {
        newSettings = null
      }
      this.block.settings = newSettings
    },
    imageUploaded(path, index, image) {
      this.$set(this.images, index, {
        path: path,
      })
      this.$set(this.block, 'data', this.images)
      this.$emit('updateData')
    },
    imageDeleted(index, image) {
      this.$delete(this.images, index)
      this.$set(this.block, 'data', this.images)
      this.$emit('updateData')
    },
    handleError() {
      iziToast.error({
        title: 'Error',
        message: this.$t('Something went wrong'),
        position: 'bottomLeft',
      })
    },
    add() {
      this.images.push({
        path: null,
      })
      this.block.data = this.images
    },
  },
}
</script>
